import { render } from "./FinancesOverview.vue?vue&type=template&id=61593705"
import script from "./FinancesOverview.vue?vue&type=script&lang=js"
export * from "./FinancesOverview.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__